import { c as _c } from "react/compiler-runtime";
import YouTubeVideoCarousel from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/YouTubeVideoCarousel';
import { ContentSection } from '@src/components/sco/LayoutBlocks/ContentSection';
import React from 'react';
export const ComprehensiveHelpContent = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <YouTubeVideoCarousel />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ContentSection component={t0} componentPlacement="left" description="Is your Pitch Deck ready for prime time? We can walk you through, slide-by-slide, exactly what you need in your pitch deck and even review it for you before it goes out. You'll have full access to live help at every step." title="Comprehensive Pitch Deck Help" buttons={[{
      title: "Get Started",
      href: "/investors/matching/start",
      variant: "cta"
    }, {
      title: "Browse Resources",
      href: "/funding",
      variant: "outlineGhost"
    }]} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};